import React from 'react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import ApiServices from 'services';
import { CLIENT_CARE_CHANGE_NEXT_STATUS } from 'commons/constants';

const ModalChangeNextStatus = ({
  clientCareHistoryItem,
  closeModalChangeStatus,
  reloadDataAfterChangeStatus,
}) => {
  const handleSubmit = async () => {
    if (!clientCareHistoryItem?.id || !clientCareHistoryItem?.clientStatusId) return;

    try {
      const res = await ApiServices.updateClientStatus(
        clientCareHistoryItem.id,
        CLIENT_CARE_CHANGE_NEXT_STATUS[clientCareHistoryItem.clientStatusId],
      );
      if (res?.status === 200) {
        window.UIMessage?.success('Thao tác thành công');
        reloadDataAfterChangeStatus();
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModalChangeStatus();
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          marginTop: '10px',
        }}
      >
        <Box sx={{ marginLeft: 'auto', display: 'flex', flexDirection: 'row' }}>
          <BtnCancel onClick={closeModalChangeStatus}>Hủy</BtnCancel>
          <BtnAccept onClick={() => handleSubmit()}>Xác nhận</BtnAccept>
        </Box>
      </Box>
    </Box>
  );
};

export { ModalChangeNextStatus };

const BtnCancel = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#555',
  opacity: 0.7,
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: '#555',
    opacity: 0.5,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));

const BtnAccept = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#13265b',
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: '#13265b',
    opacity: 0.7,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));
